export const reConstructionMaterialConstants = {
	GetList: {
		FAILURE : 'GET_LIST_CONSTRUCTION_MATERIAL_FAILURE',
		REQUEST : 'GET_LIST_CONSTRUCTION_MATERIAL_REQUEST',
		SUCCESS : 'GET_LIST_CONSTRUCTION_MATERIAL_SUCCESS'
	},
	getHierarchy: {
		FAILURE : 'GET_CATEGORIES_HIERARCHY_FOR_CONSTRUCTION_MATERIAL_FAILURE',
		REQUEST : 'GET_CATEGORIES_HIERARCHY_FOR_CONSTRUCTION_MATERIAL_REQUEST',
		SUCCESS : 'GET_CATEGORIES_HIERARCHY_FOR_CONSTRUCTION_MATERIAL_SUCCESS'
	},
	getPaged: {
		FAILURE : 'GET_PAGED_MATERIALS_LIST_FAILURE',
		REQUEST : 'GET_PAGED_MATERIALS_LIST_REQUEST',
		SUCCESS : 'GET_PAGED_MATERIALS_LIST_SUCCESS'
	},
	getPagedAll: {
		FAILURE : 'GET_All_PAGED_MATERIALS_LIST_FAILURE',
		REQUEST : 'GET_All_PAGED_MATERIALS_LIST_REQUEST',
		SUCCESS : 'GET_All_PAGED_MATERIALS_LIST_SUCCESS'
	},
	getPagedAudit: {
		FAILURE : 'GET_PAGED_AUDIT_MATERIALS_LIST_FAILURE',
		REQUEST : 'GET_PAGED_AUDIT_MATERIALS_LIST_REQUEST',
		SUCCESS : 'GET_PAGED_AUDIT_MATERIALS_LIST_SUCCESS'
	},
	getMaterialOrgPriceInfoPaged: {
		FAILURE : 'GET_MATERIAL_ORG_PRICE_INFO_FAILURE',
		REQUEST : 'GET_MATERIAL_ORG_PRICE_INFO_REQUEST',
		SUCCESS : 'GET_MATERIAL_ORG_PRICE_INFO_SUCCESS'
	},
	create: {
		FAILURE : 'CREATE_MATERIAL_FAILURE',
		REQUEST : 'CREATE_MATERIAL_REQUEST',
		SUCCESS : 'CREATE_MATERIAL_SUCCESS'
	},
	update: {
		FAILURE : 'UPDATE_MATERIAL_FAILURE',
		REQUEST : 'UPDATE_MATERIAL_REQUEST',
		SUCCESS : 'UPDATE_MATERIAL_SUCCESS'
	},
	delete: {
		FAILURE : 'DELETE_MATERIAL_FAILURE',
		REQUEST : 'DELETE_MATERIAL_REQUEST',
		SUCCESS : 'DELETE_MATERIAL_SUCCESS'
	},
	restore: {
		FAILURE : 'RESTORE_MATERIAL_FAILURE',
		REQUEST : 'RESTORE_MATERIAL_REQUEST',
		SUCCESS : 'RESTORE_MATERIAL_SUCCESS'
	},
	GetCharacteristicsFile: {
		FAILURE : 'GET_CHARACTERISTICS_MATERIALS_FILE_FAILURE',
		REQUEST : 'GET_CHARACTERISTICS_MATERIALS_FILE_REQUEST',
		SUCCESS : 'GET_CHARACTERISTICS_MATERIALS_FILE_SUCCESS'
	},
	updateClassifier: {
		FAILURE : 'UPDATE_MATERIAL_CLASSIFIER_FAILURE',
		REQUEST : 'UPDATE_MATERIAL_CLASSIFIER_REQUEST',
		SUCCESS : 'UPDATE_MATERIAL_CLASSIFIER_SUCCESS'
	},
	getExampleClassifierFile: {
		FAILURE : 'DOWNLOAD_EXAMPLE_CLASSIFIER_FILE_FAILURE',
		REQUEST : 'DOWNLOAD_EXAMPLE_CLASSIFIER_FILE_REQUEST',
		SUCCESS : 'DOWNLOAD_EXAMPLE_CLASSIFIER_FILE_SUCCESS'
	},
	CLEAR: 'CLEAR_CONSTRUCTION_MATERIAL'
}